import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Polyfill for matchMedia and addListener/removeListener (legacy support for some libraries)
if (typeof window !== 'undefined' && !window.matchMedia) {
  window.matchMedia = (query) => ({
    matches: false,
    media: query,
    onchange: null,
    addListener: () => {},
    removeListener: () => {},
    addEventListener: () => {},
    removeEventListener: () => {},
    dispatchEvent: () => false,
  });
} else if (typeof window !== 'undefined' && window.matchMedia) {
  const originalMatchMedia = window.matchMedia;
  window.matchMedia = (query) => {
    const mql = originalMatchMedia(query);
    if (mql) {
      if (!mql.addListener) mql.addListener = (cb) => mql.addEventListener('change', cb);
      if (!mql.removeListener) mql.removeListener = (cb) => mql.removeEventListener('change', cb);
    }
    return mql;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);